import React from 'react';
import { ShieldCheck, Lock, CreditCard, Users, Star, MapPin } from 'lucide-react';
export function TrustBadges({
  className = ''
}: {
  className?: string;
}) {
  const badges = [{
    icon: ShieldCheck,
    text: 'Garantía 7 días'
  }, {
    icon: Lock,
    text: 'Pago seguro'
  }, {
    icon: CreditCard,
    text: 'Mercado Pago'
  }, {
    icon: Users,
    text: '+500 alumnos'
  }, {
    icon: Star,
    text: '4.9 Rating'
  }, {
    icon: MapPin,
    text: 'Todo Argentina'
  }];
  return <div className={`flex flex-wrap items-center justify-center gap-4 text-sm text-gray-400 ${className}`} data-id="element-247">
      {badges.map((badge, index) => <div key={index} className="flex items-center gap-1.5" data-id="element-248">
          <badge.icon className="w-4 h-4 text-brand" data-id="element-249" />
          <span className="font-medium" data-id="element-250">{badge.text}</span>
        </div>)}
    </div>;
}